//Componentes generales
import { useContext, useEffect, useRef, useState } from 'react';
import {
    Route,
    Routes,
    Navigate,
    useLocation,
    useNavigate
} from "react-router-dom";

//Views
import Login from "../../views/login/Login";
import Home from "../../views/home/Home";
import User from "../../views/user/User";
import Product from "../../views/product/Product";
import SharedLayout from "../../components/sharedLayout/SharedLayout";
import AddReq from "../../views/addReq/AddReq";
import Grupos from '../../views/Grupos/Grupos';
import Control from '../../views/Control/Control';
import Activos from '../../views/activos/Activos';
import Procedimientos from '../../views/procedimientos/Procedimientos.js';
import Documentos from '../../views/documentos/Documentos.js';
import CategoriasRRHH from '../../views/categoriasRRHH/CategoriasRRHH.js';
import Legajo from '../../views/legajo/Legajo.js';
import Proveedor from '../../views/proveedor/Proveedor.js';
import TemplatesProduccion from '../../views/templatesProduccion/TemplatesProduccion.js';
import SignUp from '../../views/signUp/SignUp.js';
import ConfirmEmail from '../../views/confirmEmail/ConfirmEmail.js';
import RecoverPassword from '../../views/recoverPassword/RecoverPassword.js';
import NewPassword from '../../views/newPassword/NewPassword.js';

//Rutas
import Routes_gral from "../Routes_gral";

import authContext from "../../context/authentication/authContex";

//Token
import tokenAuth from "../../config/token";
import ProcedimientosProgramados from '../../views/procedimientosProgramados/ProcedimientosProgramados.js';
import Informes from '../../views/informes/Informes.js';
import PageABMs from '../../views/pageABMs/PageABMs.js';
import Checklist from '../../views/checklist/Checklist.js';
import ChecklistRegistrados from '../../views/checklistRegistrados/ChecklistRegistrados.js';
import Consumos from '../../views/consumos/Consumos.js';
import OPD from '../../views/opd/OPD.js';
import AppMobile from '../../views/appMobile/AppMobile.js';
import Ayuda from '../../views/ayuda/Ayuda.js';
import { ErrorPage } from '../../views/errorPage/ErrorPage.js';
import ActivosSupervisorView from '../../views/activosSupervisorView/ActivosSupervisorView.js';
import Swal from 'sweetalert2';
import Dictionary from '../../views/dictionary/Dictionary.js';
import GlobalSettings from '../../views/globalSettings/GlobalSettings.js';
import ReservasCanchas from '../../views/reservasCanchas/ReservasCanchas.js';
import MisReservas from '../../views/misReservas/MisReservas.js';
import ExplicacionReservas from '../../views/reservasCanchas/ExplicacionReservas.js';
import BloqueadoReserva from '../../views/bloqueadoReserva/BloqueadoReserva.js';
import Notificaciones from '../../views/notificaciones/Notificaciones.js';

// Revisar si tenemos un token
const token = localStorage.getItem('token');

if (token) {
    tokenAuth(token);
}

const ProtectedRoute = ({condition, children, redirecPath = "/error", routeTo = ''}) => {

    //Obtiene la ruta que esta intentando renderizar, ejemplo /activos o /procsProgramados.
    const location = useLocation();
    
    //Obtiene el valor de la validación.
    const isAllowed = typeof condition == 'function' ? condition() : condition;

    //Si no esta permitido lo redirige a la pagina de error.
    if(!isAllowed){
        return <Navigate to={redirecPath} replace state={{from: location.pathname}}/>;
    }
    //Si esta permitido lo redirige a la pagina solicitada.
    return children;
}

function Rutas() {
    const location = useLocation();

    const isFirstRender = useRef(true);
    const userAlreadyAuthenticated = useRef(false);
    const routeToRedirectForced = useRef('');

    const [usuarioLogged,setUsuarioLogged] = useState(false);

    //Context de AutenticacioRoutes_graln
    const aContext = useContext(authContext);
    const { usuario, usuarioAutenticado, checkIfAdmin, checkIfOnlyRevisor, checkIfAdminOrAdminNoABMs, checkIfSupervisor, checkIfMachinistic, checkIfMechanic, checkIfSocio, checkIfCanchero, checkIfGestorReservas, checkIfRevisorReservas, checkIfSupervisorOrAdmin } = aContext;
    const navigate = useNavigate();

    // useEffect(() => {
    //     usuarioAutenticado()
    // }, []);

    useEffect(()=>{
        if(usuario){
            setUsuarioLogged(true);
            userAlreadyAuthenticated.current = true;
        } 
        else setUsuarioLogged(false);
    },[usuario]);

    useEffect(()=>{
        
        Swal.fire({
            title:"Aguarde...",
            didOpen: () => {
                Swal.showLoading();
            }
        });

        //Al tardar en setear el usuario cuando se clickea un elemento que abre una nueva pestaña es necesario setear a la ruta que redirecciona para luego redirigir al usuario a esa direccion si es que tiene los permisos disponibles.
        if(isFirstRender.current && [Routes_gral.documentos, Routes_gral.home, Routes_gral.procsProgramados, Routes_gral.checkListRegistrados, Routes_gral.reservasCanchas, Routes_gral.explicacionReservas].includes(location.pathname)){
            routeToRedirectForced.current = location.pathname;
        }
        if(usuarioLogged && !usuario.mustChangePassword){
            //Redireccionamiento logico.
            if(usuario && (checkIfSocio() || checkIfCanchero() || checkIfGestorReservas() || checkIfRevisorReservas() || checkIfAdmin()) && [ Routes_gral.reservasCanchas, Routes_gral.explicacionReservas].includes(routeToRedirectForced.current)){
                isFirstRender.current = false;
                let routeToGo = routeToRedirectForced.current;
                routeToRedirectForced.current = '';
                navigate(routeToGo, {replace:true});
            }else if(usuario && (checkIfMachinistic() || checkIfMechanic())){
                navigate(Routes_gral.appMobile);
            }else if(usuario && checkIfSupervisorOrAdmin() && [Routes_gral.procsProgramados, Routes_gral.home, Routes_gral.documentos, Routes_gral.checkListRegistrados, Routes_gral.reservasCanchas, Routes_gral.explicacionReservas].includes(routeToRedirectForced.current)){
                isFirstRender.current = false;
                let routeToGo = routeToRedirectForced.current;
                routeToRedirectForced.current = '';
                navigate(routeToGo, {replace:true});
            }else if(usuario && (checkIfOnlyRevisor() || checkIfSupervisor())){
                navigate(Routes_gral.tableroSupervisor, {replace:true})
            } else if (usuario && checkIfAdminOrAdminNoABMs()){
                navigate(Routes_gral.activos, {replace:true})
            }else if(usuario && (checkIfSocio() || checkIfCanchero() || checkIfGestorReservas() || checkIfRevisorReservas())){
                navigate(Routes_gral.reservasCanchas, {replace:true})
            }
            Swal.close();
        } else {
            let rutasToIgnore = [Routes_gral.recoverPassword, Routes_gral.newPassword, Routes_gral.error, Routes_gral.signup, Routes_gral.confirmEmail, Routes_gral.login, Routes_gral.newPassword]
            
            if(rutasToIgnore.includes(location.pathname) || location.pathname.includes('newPassword') || location.pathname.includes('confirmEmail')) Swal.close();

            setTimeout(()=>{
                //Si usuario no esta autenticado y la ruta no debe ser ignorado ni la ruta incluye ni newPassword ni confirmEmail, arrojar Acceso no Autorizado.
                if(!userAlreadyAuthenticated.current && (!rutasToIgnore.includes(location.pathname) && (!location.pathname.includes('newPassword') && !location.pathname.includes('confirmEmail')))) Swal.fire({
                    title:'Acceso no autorizado!',
                    text:"Usuario no logueado",
                    showConfirmButton:true,
                    confirmButtonText:"Iniciar Sesión",
                    showCancelButton:true
                }).then(res => {
                    if(res.isConfirmed){
                        navigate(Routes_gral.login, {replace:true});
                    }
                })
                
            },10000);
        }
    },[usuarioLogged]);

    return (
        <div className="App">
            <Routes>
                {/* Tab Activos */}
                    <Route path={Routes_gral.activos} element={<ProtectedRoute condition={checkIfAdminOrAdminNoABMs} > <SharedLayout section={"Tablero Activos"}> <Activos /> </SharedLayout> </ProtectedRoute>} />
                    <Route path={Routes_gral.tableroSupervisor} element={<ProtectedRoute condition={()=> (checkIfSupervisor() || checkIfOnlyRevisor())} > <SharedLayout section={"Tablero Supervisor"}> <ActivosSupervisorView /> </SharedLayout> </ProtectedRoute>} />
                    {/* <Route path={Routes_gral.tableroSupervisor} element={<ProtectedRoute condition={checkIfSupervisor} > <SharedLayout section={"Tablero Supervisor"}> <ActivosSupervisorView /> </SharedLayout> </ProtectedRoute>} /> */}
                {/* Fin Tab Activos */}
                
                
                {/* Registrados/Registraciones */}
                    <Route path={Routes_gral.addReq} element={<ProtectedRoute condition={checkIfAdminOrAdminNoABMs}> <SharedLayout section={"Nueva Orden de Trabajo"}> <AddReq edicion={usuario} /> </SharedLayout> </ProtectedRoute>} />
                    <Route path={Routes_gral.home} element={<ProtectedRoute condition={checkIfSupervisorOrAdmin}> <SharedLayout section={"Órdenes de Trabajo"}> <Home /> </SharedLayout> </ProtectedRoute>} />
                    <Route path={Routes_gral.procsProgramados} element={<ProtectedRoute condition={checkIfSupervisorOrAdmin}> <SharedLayout section={"Procedimientos Programados"}> <ProcedimientosProgramados /> </SharedLayout> </ProtectedRoute>} />
                    <Route path={Routes_gral.documentos} element={<ProtectedRoute condition={checkIfAdminOrAdminNoABMs}> <SharedLayout section={"Documentos"}> <Documentos /> </SharedLayout> </ProtectedRoute>} />
                    <Route path={Routes_gral.checkListRegistrados} element={<ProtectedRoute condition={checkIfSupervisorOrAdmin}> <SharedLayout section={"Checklist Registrados"}> <ChecklistRegistrados /> </SharedLayout> </ProtectedRoute>} />
                    <Route path={Routes_gral.consumos} element={<ProtectedRoute condition={checkIfAdminOrAdminNoABMs}> <SharedLayout section={"Consumos"}> <Consumos /> </SharedLayout> </ProtectedRoute>} />
                    <Route path={Routes_gral.opd} element={<ProtectedRoute condition={checkIfSupervisorOrAdmin}> <SharedLayout section={"Órdenes de Producción"}> <OPD /> </SharedLayout> </ProtectedRoute>} />
                {/* Fin Registrados/Registraciones */}

                {/* ABMs */}
                    <Route path={Routes_gral.control} element={<ProtectedRoute condition={checkIfAdmin}> <SharedLayout section={"Activos"}><Control /></SharedLayout> </ProtectedRoute>} />
                    <Route path={Routes_gral.procedimientos} element={<ProtectedRoute condition={checkIfAdmin}> <SharedLayout section={"Procedimientos"}> <Procedimientos /> </SharedLayout> </ProtectedRoute>} />
                    <Route path={Routes_gral.group} element={<ProtectedRoute condition={checkIfAdmin}> <SharedLayout section={"Grupos"}> <Grupos /> </SharedLayout> </ProtectedRoute>} />
                    <Route path={Routes_gral.reports} element={<ProtectedRoute condition={checkIfAdmin}> <SharedLayout section={"Reports"}> <Informes /> </SharedLayout> </ProtectedRoute>} />
                    <Route path={Routes_gral.product} element={<ProtectedRoute condition={checkIfAdmin}> <SharedLayout section={"Productos"}> <Product /> </SharedLayout> </ProtectedRoute>} />
                    <Route path={Routes_gral.checkList} element={<ProtectedRoute condition={checkIfAdmin}> <SharedLayout section={"Checklist"}> <Checklist /> </SharedLayout> </ProtectedRoute>} />
                    <Route path={Routes_gral.user} element={<ProtectedRoute condition={checkIfAdmin}> <SharedLayout section={"Usuarios"}> <User /> </SharedLayout> </ProtectedRoute>} />
                    <Route path={Routes_gral.legajos} element={<ProtectedRoute condition={checkIfAdmin}> <SharedLayout section={"Legajos"}> <Legajo /> </SharedLayout> </ProtectedRoute>} />
                    <Route path={Routes_gral.categoriasRRHH} element={<ProtectedRoute condition={checkIfAdmin}> <SharedLayout section={"Categorías RRHH"}> <CategoriasRRHH /> </SharedLayout> </ProtectedRoute>} />
                    <Route path={Routes_gral.proveedores} element={<ProtectedRoute condition={checkIfAdmin}> <SharedLayout section={"Proveedores"}> <Proveedor /> </SharedLayout> </ProtectedRoute>} />
                    <Route path={Routes_gral.templatesProduccion} element={<ProtectedRoute condition={checkIfAdmin}> <SharedLayout section={"Templates de Produccion"}> <TemplatesProduccion /> </SharedLayout> </ProtectedRoute>} />
                    <Route path={Routes_gral.bloqueadosReserva} element={<ProtectedRoute condition={checkIfAdmin}> <SharedLayout section={"Bloqueados para Reservar"}> <BloqueadoReserva /> </SharedLayout> </ProtectedRoute>} />
                    <Route path={Routes_gral.abms} element={<ProtectedRoute condition={checkIfAdmin}> <SharedLayout section={"ABMs"}> <PageABMs /> </SharedLayout> </ProtectedRoute>} />
                {/* Fin ABMs */}
                
                
                <Route path={Routes_gral.appMobile} element={<ProtectedRoute condition={true}> <SharedLayout section={"App Mobile"}> <AppMobile/> </SharedLayout> </ProtectedRoute>} />
                
                
                {/* Top-Bar */}
                    <Route path={Routes_gral.ayuda} element={<ProtectedRoute condition={true}> <SharedLayout section={"Ayuda"}> <Ayuda/> </SharedLayout></ProtectedRoute>} />
                    <Route path={Routes_gral.globalSettings} element={<ProtectedRoute condition={true}> <SharedLayout section={"Configuración Global"}><GlobalSettings/></SharedLayout>  </ProtectedRoute>} />
                    <Route path={Routes_gral.diccionario} element={<ProtectedRoute condition={checkIfAdmin}> <SharedLayout section={"Diccionario"}> <Dictionary /> </SharedLayout> </ProtectedRoute>} />
                    <Route path={Routes_gral.notificaciones} element={<ProtectedRoute condition={true}> <SharedLayout section={"Notificaciones"}> <Notificaciones /> </SharedLayout> </ProtectedRoute>} />
                {/* Fin Top-Bar */}

                {/* Reservas de Canchas */}
                    <Route path={Routes_gral.reservasCanchas} element={<ProtectedRoute condition={true}> <SharedLayout section={"Reservas de Canchas"}> <ReservasCanchas /> </SharedLayout> </ProtectedRoute>} />
                    <Route path={Routes_gral.misReservas} element={<ProtectedRoute condition={() => !checkIfCanchero() && !checkIfRevisorReservas()}> <SharedLayout section={"Mis Reservas"}> <MisReservas /> </SharedLayout> </ProtectedRoute>} />
                    <Route path={Routes_gral.explicacionReservas} element={<ProtectedRoute condition={true}> <SharedLayout section={"Explicación Técnica - Reservas"}> <ExplicacionReservas /> </SharedLayout> </ProtectedRoute>} />
                {/* Fin Reservas de Canchas */}

                {/* Sin autenticación */}
                    <Route path={Routes_gral.signup} element={<SignUp />} />
                    <Route path={Routes_gral.confirmEmail} element={<ConfirmEmail />} />
                    <Route path={Routes_gral.recoverPassword} element={<RecoverPassword />} />
                    <Route path={Routes_gral.newPassword} element={<NewPassword />} />
                    <Route path={Routes_gral.error} element={ <SharedLayout section={"Error"}><ErrorPage /></SharedLayout>} />
                    <Route path="*" element={<Navigate to={Routes_gral.error} replace />}/>
                    <Route path={Routes_gral.login} element={<Login />} />
                {/* Fin Sin autenticación */}
            </Routes>
        </div>
    )
}

export default Rutas;
